<template>
  <div class="product-category-selector">
    <select id="dashboard-category-filter" v-model="selectedCategory" @change="filterByCategory">
      <option value="">All Categories</option>
      <option v-for="category in productCategories" :key="category.id" :value="category.id">
        {{ category.title }}
      </option>
    </select>
  </div>
</template>

<script>
import axios from 'axios';
import { EventBus } from './event-bus';

export default {
  name: 'v-product-category-selector',
  data() {
    return {
      productCategories: [],
      selectedCategory: ''
    };
  },
  mounted() {
    // Load product categories
    this.loadProductCategories();
    
    // Restore saved category filter preference
    const savedCategory = localStorage.getItem('selectedProductCategory');
    if (savedCategory) {
      this.selectedCategory = savedCategory;
      // Emit the saved category on mount to initialize with saved filter
      this.$nextTick(() => {
        this.filterByCategory();
      });
    }
  },
  methods: {
    
    loadProductCategories() {
      axios.get('/api/v1/product-categories')
        .then(response => {
          this.productCategories = response.data.data;
        })
        .catch(error => {
          console.error('Error loading product categories:', error);
        });
    },
    
    filterByCategory() {
      // Save selection to local storage
      localStorage.setItem('selectedProductCategory', this.selectedCategory);
      
      // Emit event with selected category
      EventBus.$emit('product-category-selected', this.selectedCategory);
    }
  }
};
</script>

<style scoped>
.product-category-selector {
  margin: 15px 0 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 15px;
  max-width: 100%;
}

.product-category-selector select {
  padding: 6px 12px;
  border-radius: 4px;
  border: 1px solid #ccc;
  background-color: white;
  min-width: 200px;
  max-width: 300px;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/ProductCategorySelector.vue